// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function LightningDashedCircleIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M15 3.978A1 1 0 0 1 16 3c.388 0 .773.017 1.153.05C23.793 3.635 29 9.21 29 16c0 1.251-.177 2.463-.508 3.61a1 1 0 1 1-1.922-.554c.28-.969.43-1.994.43-3.056 0-5.738-4.394-10.451-10-10.955l-1.044-.046A1 1 0 0 1 15 3.979ZM12.375 5.61a1 1 0 1 0-.658-1.888c-1.035.361-2.01.85-2.906 1.445a1 1 0 1 0 1.107 1.666 10.957 10.957 0 0 1 2.457-1.222ZM7.292 9.278A1 1 0 0 0 5.71 8.055 12.948 12.948 0 0 0 3 16c0 .488.027.969.08 1.443a1 1 0 1 0 1.987-.22C5.023 16.824 5 16.414 5 16c0-2.533.855-4.863 2.292-6.722ZM4.944 20.778a1 1 0 0 1 1.353.41 11.039 11.039 0 0 0 6.036 5.186 1 1 0 0 1-.666 1.886 13.039 13.039 0 0 1-7.132-6.128 1 1 0 0 1 .409-1.354ZM26.11 24.172a1 1 0 0 0-1.554-1.258A10.977 10.977 0 0 1 16 27a1 1 0 1 0 0 2c4.084 0 7.73-1.885 10.11-4.828Z"
					/>
					<path
						fill="currentColor"
						d="M22.707 13.374a1 1 0 0 0-1.414-1.414L18 15.252l-1.96-1.96a1 1 0 0 0-1.414 0l-5.333 5.334a1 1 0 1 0 1.414 1.414l4.626-4.626 1.96 1.96a1 1 0 0 0 1.414 0l4-4Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
